//RTK
import { createSlice } from "@reduxjs/toolkit";

//Lodash
import { get } from "lodash";

//Local imports
import { dispatch } from "store";
import { PAGINATION } from "utils/constants/pagination";
import authApi from "interceptor/authInterceptor";
const { INITIAL_PAGE, ROWS_PER_PAGE } = PAGINATION;

// types
export type AuditLogsStateProps = {
  logsList: any[];
  metadata: any | null;
  totalItems: number;
  totalPages: number;
  pageNo: number;
  pageSize: number;
  loader: boolean;
  error: any | null;
};

// initial state
const initialState: AuditLogsStateProps = {
  logsList: [],
  metadata: null,
  totalItems: 0,
  totalPages: 0,
  pageNo: INITIAL_PAGE,
  pageSize: ROWS_PER_PAGE,
  loader: false,
  error: null,
};

// ==============================|| SLICE - AUDIT LOGS ||============================== //

const auditLogsData = createSlice({
  name: "auditLogsData",
  initialState,
  reducers: {
    getAuditLogsData(state, action) {
      let {
        logsList,
        totalItems,
        totalPages,
        pageNo,
        pageSize,
      } = action.payload;
      state.logsList = logsList || initialState.logsList;
      state.totalItems = totalItems;
      state.totalPages = totalPages;
      state.pageNo = pageNo || initialState.pageNo;
      state.pageSize = pageSize || initialState.pageSize;
    },
    getMetadata(state, action) {
      state.metadata = action.payload;
    },
    isLoading(state, action) {
      state.loader = action.payload;
    },
    hasError(state, action) {
      state.error = action.payload;
    },
    clearAuditLogs: () => initialState,
  },
});

export default auditLogsData.reducer;

export const { getAuditLogsData, getMetadata, isLoading, hasError, clearAuditLogs } =
  auditLogsData.actions;

export function fetchAuditLogsData(page: any, pageSize: any, fromDate: any, toDate: any, module: string, actionFilter: string, search: string, status: string, companyId: string, roleFilter: string, myLogsFilter: boolean) {
  const startDate = !fromDate ? "" : fromDate;
  const endDate = !toDate ? "" : toDate;
  const size = pageSize < 5 ? 10 : pageSize;
  const mod = module ? module : "";
  const act = actionFilter ? actionFilter : "";
  const querySearch = search ? search : "";
  const statusFilter = status ? status : "";
  const company = companyId ? companyId : "";
  const rFilter = roleFilter ? roleFilter : "";
  const mLogs = myLogsFilter ? "true" : "false";
  
  const apiPage = Number(page) + 1;

  return async () => {
    dispatch(isLoading(true));
    try {
      const response = await authApi.get(
        `/v2/api/audit-trail/logs?page=${apiPage}&limit=${size}&startDate=${startDate}&endDate=${endDate}&module=${mod}&action=${act}&search=${querySearch}&status=${statusFilter}&companyId=${company}&role=${rFilter}&myLogs=${mLogs}`
      );
      if (response.data) {
        const data = get(response, "data.data", []);
        const pagination = get(response, "data.pagination", { total: 0, totalPages: 0 });
        dispatch(
          getAuditLogsData({
            logsList: data,
            totalItems: pagination.total,
            totalPages: pagination.totalPages,
            pageNo: page,
            pageSize: size,
          })
        );
      }
    } catch (error) {
      dispatch(hasError(error));
    } finally {
      dispatch(isLoading(false));
    }
  };
}

export function fetchAuditLogsMetadata() {
  return async () => {
    try {
      const response = await authApi.get(`/v2/api/audit-trail/metadata`);
      if (response.data) {
        const data = get(response, "data.data", null);
        dispatch(getMetadata(data));
      }
    } catch (error) {
      dispatch(hasError(error));
    }
  };
}
